import { render } from "./loanapply.vue?vue&type=template&id=b75bd7bc&scoped=true"
import script from "./loanapply.vue?vue&type=script&lang=js"
export * from "./loanapply.vue?vue&type=script&lang=js"

import "./loanapply.vue?vue&type=style&index=0&id=b75bd7bc&scoped=true&lang=css"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b75bd7bc"]])

export default __exports__